/**
 * Matching de rutas admin con soporte para ?tab= y #hash (sidebar / breadcrumb / dock).
 */

export function adminNavPathname(to: string): string {
  let result = to;
  const q = result.indexOf("?");
  if (q !== -1) result = result.slice(0, q);
  const h = result.indexOf("#");
  if (h !== -1) result = result.slice(0, h);
  return result;
}

export function adminNavSearch(to: string): string {
  const q = to.indexOf("?");
  if (q === -1) return "";
  let search = to.slice(q);
  const h = search.indexOf("#");
  if (h !== -1) search = search.slice(0, h);
  return search;
}

export function adminNavHash(to: string): string {
  const h = to.indexOf("#");
  return h === -1 ? "" : to.slice(h);
}

/** true si la ruta actual coincide con un ítem del sidebar (incl. query en `to`). */
export function isAdminNavItemActive(
  itemTo: string,
  itemEnd: boolean,
  pathname: string,
  search: string,
  hash: string,
): boolean {
  const itemPath = adminNavPathname(itemTo);
  const itemSearch = adminNavSearch(itemTo);
  const itemHash = adminNavHash(itemTo);

  if (itemSearch) {
    if (pathname !== itemPath) return false;
    if (search !== itemSearch) return false;
    if (itemHash && hash !== itemHash) return false;
    return true;
  }

  // Ítem sin query: no activar si la URL tiene ?tab= u otros params (p. ej. /admin/analytics vs ?tab=mux).
  if (itemEnd) {
    if (pathname !== itemPath) return false;
    if (search) return false;
    return true;
  }
  if (pathname === itemPath) {
    if (search) return false;
    return true;
  }
  if (pathname.startsWith(itemPath + "/")) return true;
  return false;
}